import React, { useEffect, useState, useRef } from "react"
import "./EditProgram.scss"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputText } from "primereact/inputtext"
import UniversityApi from "Api/UniversityApi"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Dropdown } from "primereact/dropdown"
import programApi from "Api/programApi"
import { Calendar } from "primereact/calendar"
import { Toast } from 'primereact/toast'

const EditProgram = () => {
  document.title = "Edit Program"
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))
  const location = useLocation("")
  const program = location?.state
  const [loading, setLoading] = useState(false)
  const toast = useRef(null);

  const refinedProgramData = {
    ...program,
    modeOfStudy: {
      name:
        program?.modeOfStudy?.charAt(0).toUpperCase() +
        program?.modeOfStudy?.slice(1),
      code:
        program?.modeOfStudy?.charAt(0).toUpperCase() +
        program?.modeOfStudy?.slice(1),
    },
    verifiedStatus: {
      name:
        program?.verifiedStatus?.charAt(0)?.toUpperCase() +
        program?.verifiedStatus?.slice(1),
      code:
        program?.verifiedStatus?.charAt(0)?.toUpperCase() +
        program?.verifiedStatus?.slice(1),
    },
    verifiedReason: program?.verifiedReason ? program?.verifiedReason : "",
    institution: program?.institution ? {
      _id: program?.institution?._id,
      institutionName: program?.institution?.institutionName,
      institutionCode: program?.institution?.institutionCode,
      displayName: program?.institution?.displayName,
      category: program?.institution?.category,
    } : null,
  }

  const [programData, setProgramData] = useState(refinedProgramData)

  const handleProgramDataChange = (name, value) => {
    setProgramData(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }
  const modeofStudyOptions = [
    { name: "Online", code: "Online" },
    { name: "Offline", code: "Offline" },
    { name: "Hybrid", code: "Hybrid" },
  ]
  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Program", link: "#" },
    { label: "Edit Program", link: "#" },
  ]

  const [uniMenu, setUniMenu] = useState([])
  const universityDropDown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniMenu(res.data.university)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    universityDropDown()
    fetchInstituteByUniId(programData?.university?.universityCode)
  }, [accessToken, program])

  const [instituteMenu, setInstituteMenu] = useState([])
  const fetchInstituteByUniId = universityCode => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
    UniversityApi.getCollegesByUniversity(universityCode, config)
      .then(res => {
        console.log("Institute Menu Data:", res.data.colleges);
        setInstituteMenu(res.data.colleges)
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    console.log("Program Data:", programData);
    console.log("Institute Menu:", instituteMenu);
  }, [programData, instituteMenu]);

  const updateProgram = () => {
    const payload = {
      // ...programData,
      university: programData?.university?._id,
      // modeOfStudy: programData?.modeOfStudy?.name?.toLowerCase(),
      verifiedStatus: programData?.verifiedStatus?.name?.toLowerCase(),
      institution: programData?.institution?._id,
      programId: programData?._id,
    }

    console.log(payload, "==================>payload")
    // return;
    setLoading(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    programApi
      .updatePorgram(payload, config)
      .then(res => {
        if (res.data.status) {
          setLoading(false)
          setTimeout(() => {
            navigate("/programlist")
          }, 1000)
          toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
        }
      })
      .catch(error => {
        setLoading(false)
        console.log(error)
        toast.current.show({ severity: 'error', summary: 'Error', detail: error?.response?.data?.message, life: 3000 });
      })
  }

  return (
    <div className="edit-Program">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="program-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Edit Program" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="program-edit-form">
                <div className="program-edit-inp">
                  <label htmlFor="university">University</label>
                  <div className="inp-err">
                    <Dropdown
                      value={programData.university}
                      onChange={e => {
                        handleProgramDataChange("university", e.value)
                        fetchInstituteByUniId(e.value.universityCode)
                      }}
                      disabled
                      options={uniMenu}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="Institution">Institution</label>
                  <div className="inp-err">
                    <Dropdown
                      value={programData.institution}
                      onChange={e => {
                        handleProgramDataChange("institution", e.value)
                      }}
                      disabled
                      options={instituteMenu}
                      optionLabel="institutionName"
                      placeholder="Select Institution"
                      filter
                      className="w-100"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="ProgramName" className="label">
                    Program Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="ProgramName"
                      value={programData.programName}
                      onChange={e =>
                        handleProgramDataChange("programName", e.target.value)
                      }
                      readOnly
                      placeholder="Enter Program Name"
                      className="inp-field-box"
                    />
                  </div>
                </div>
                {/* 
                <div className="program-edit-inp">
                  <label htmlFor="duration" className="label">
                    Duration
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="duration"
                      value={programData.duration}
                      onChange={e =>
                        handleProgramDataChange("duration", e.target.value)
                      }
                      placeholder="Enter Duration"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="level" className="label">
                    Level
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="level"
                      value={programData.level}
                      onChange={e =>
                        handleProgramDataChange("level", e.target.value)
                      }
                      placeholder="Enter Level"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="EligibilityCriteria" className="label">
                    EligibilityCriteria
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="eligibilityCriteria"
                      value={programData.eligibilityCriteria}
                      onChange={e =>
                        handleProgramDataChange(
                          "eligibilityCriteria",
                          e.target.value,
                        )
                      }
                      placeholder="Enter EligibilityCriteria"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="totalSeats" className="label">
                    TotalSeats
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalSeats"
                      value={programData.totalSeats}
                      onChange={e =>
                        handleProgramDataChange("totalSeats", e.target.value)
                      }
                      placeholder="Enter TotalSeats"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="tuitionFee" className="label">
                    TuitionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="tuitionFee"
                      value={programData.tuitionFee}
                      onChange={e =>
                        handleProgramDataChange("tuitionFee", e.target.value)
                      }
                      placeholder="Enter TuitionFee"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="admissionFee" className="label">
                    AdmissionFee
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="admissionFee"
                      value={programData.admissionFee}
                      onChange={e =>
                        handleProgramDataChange("admissionFee", e.target.value)
                      }
                      placeholder="Enter AdmissionFee"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="Scholarship" className="label">
                    Scholarship
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="Scholarship"
                      value={programData.scholarships}
                      onChange={e =>
                        handleProgramDataChange("scholarships", e.target.value)
                      }
                      placeholder="Enter Scholarship"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="intakeSeats" className="label">
                    Intake Seats
                  </label>
                  <div className="inp-err">
                  <InputText
                      id="intakeSeats"
                      value={programData.intakeSeats}
                      onChange={e =>
                        handleProgramDataChange("intakeSeats", e.target.value)
                      }
                      placeholder="Enter Intake Seats"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="modeOfStudy">Mode Of Study</label>
                  <div className="inp-err">
                    <Dropdown
                      id="modeOfStudy"
                      value={programData.modeOfStudy}
                      onChange={e =>
                        handleProgramDataChange("modeOfStudy", e.value)
                      }
                      optionLabel="name"
                      options={modeofStudyOptions}
                      placeholder=" Select Mode of Study"
                    />
                  </div>
                </div>

                <div className="program-edit-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={programData.description}
                      onChange={e =>
                        handleProgramDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                  </div>
                </div> */}

                {userData.role === "manager" && (
                  <>
                    <div className="program-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={programData.verifiedStatus}
                          onChange={e =>
                            handleProgramDataChange("verifiedStatus", e.value)
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                      </div>
                    </div>

                    <div className="program-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={programData.verifiedReason}
                          onChange={e =>
                            handleProgramDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    updateProgram()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditProgram
